module.exports = __webpack_public_path__ + "img/shift-stick.d4197ff7.png";